import {useMutation} from '@tanstack/react-query';
import {API, type FeedbackPayload} from '@chekin/api';
import {useIsMounted} from '@chekin/guestapp-ui-kit';

type Props = {
  onError?: (error: Error) => void;
  onSuccess?: (data: FeedbackPayload) => void;
};
function useMutateCheckoutFeedback({onError, onSuccess}: Props = {}) {
  const isMounted = useIsMounted();

  const {mutate, status} = useMutation<FeedbackPayload, Error, FeedbackPayload>({
    mutationFn: payload => API.feedback.createCheckoutFeedback(payload),
    onError: error => {
      if (!isMounted.current) {
        return;
      }
      onError?.(error);
    },
    onSuccess,
  });

  return {createCheckoutFeedbackMutation: mutate, status};
}

export {useMutateCheckoutFeedback};
